import { string, number, object } from 'yup';

export const validationSchema = object().shape({
  amount: object().shape({
    amount: number().nullable().required('Payment amount is required'),
    currency: string().nullable().required('Payment currency is required'),
  }),
  reason: string().nullable().required('A reason is required'),
}).nullable();
